module.exports = __webpack_public_path__ + "img/banner.ff37d3f7.jpg";